// extracted by mini-css-extract-plugin
module.exports = {"container":"AddDocumentModal_container__ZJu3B"};